/** @jsx jsx */
import { jsx } from '@emotion/core'
import { FunctionComponent, InputHTMLAttributes } from 'react'
import { colors, typeRamp } from '../../constants'
import {
	InputValidationState,
	INPUT_VALIDATION_STATE_INVALID,
} from './constants'

interface Props extends InputHTMLAttributes<HTMLInputElement> {
	validationState?: InputValidationState
}

const TextInput: FunctionComponent<Props> = ({ validationState, ...props }) => {
	return (
		<input
			css={{
				position: 'relative',
				width: '100%',
				...(typeRamp.light_16 as any),
				color: colors.grey,
				border: 0,
				backgroundColor: 'none',
				borderBottom: `1px solid ${colors.ink}`,
				padding: '0.5rem 0',
			}}
			{...props}
		/>
	)
}

export default TextInput
